import React from "react";
import {addKeywordItem} from "../../API/keyword";
import {getAdvices} from "../../API/advices";
import {useEffect, useState} from "react";
import uuid from 'react-uuid';
import {clearHTML} from "../../Utils/helpers";


function KeywordToolComponent() {

    let [adviceData, setadviceData] = useState([]);


    const addItem = () => {
        let text = document.getElementById('ignoreItem').value;
        let select = document.getElementById('tagOption');
        let type = select.options[select.selectedIndex].text;
        if (text) {
            let item = {"keyword": text, "tag": type};
            addKeywordItem(item)
        }
    };

    useEffect(async () => {
        adviceData = await getAdvices().then((result) => {
            console.log("data", result)
            return result.response.map(e =>
            <option key={uuid}>{clearHTML(e.norm)}</option>
        );
        });

        setadviceData(adviceData);
    }, []);


    return (<>

        <div className="row">

            &emsp; <label className="text-white">Hinzufügen: </label>
            <div className="col-lg align-self-center">
                <input className="normal col-lg" id="ignoreItem" type="text"/></div>
            &emsp; <label className="text-white"> AI tag: </label>
            &emsp;
            <div className="col-4">
                <select className="custom-select" id="tagOption">
                    {adviceData}
                </select></div>
            <div className="col-2">
                <button className="btn handwai-btn-create" onClick={() => addItem()}>Speichern</button>
            </div>

        </div>
    </>);
}

export default KeywordToolComponent;